import { Grid, CommandColumn as Command } from '@syncfusion/ej2-grids';
/**
 * Command Column Module for TreeGrid
 *
 * @hidden
 */
export class CommandColumn {
    constructor(parent) {
        Grid.Inject(Command);
        this.parent = parent;
    }
    /**
     * For internal use only - Get the module name.
     *
     * @private
     * @returns {string} Returns CommandColumn module name
     */
    getModuleName() {
        return 'commandColumn';
    }
    /**
     * Destroys the ContextMenu.
     *
     * @function destroy
     * @returns {void}
     */
    destroy() {
        //this.removeEventListener();
    }
}
